const URL = process.env.NODE_ENV === 'production' ? 'https://api.padelnationpe.com/api/store/' : 'http://localhost:8000/api/store/';
export default URL; 